const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

const ensureFbq = () => {
  if (typeof window === 'undefined') return null;
  if (window.fbq) return window.fbq;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  return window.fbq;
};

export const initMetaPixel = () => {
  if (!PIXEL_ID || typeof window === 'undefined' || initialized) return;

  const fbq = ensureFbq();
  if (!fbq) return;

  fbq('init', PIXEL_ID);
  initialized = true;
};

export const trackPageView = () => {
  if (!PIXEL_ID || typeof window === 'undefined') return;
  const fbq = window.fbq || ensureFbq();
  if (!fbq) return;
  if (!initialized) initMetaPixel();
  fbq('track', 'PageView');
};

export const track = (eventName, params) => {
  if (!PIXEL_ID || typeof window === 'undefined' || !eventName) return;
  const fbq = window.fbq || ensureFbq();
  if (!fbq) return;
  if (!initialized) initMetaPixel();
  if (params) {
    fbq('track', eventName, params);
    return;
  }
  fbq('track', eventName);
};

export default {
  initMetaPixel,
  trackPageView,
  track
};
